import type {
  ImportedModelTabType,
  PuppyPackageDocumentType,
} from '@puppycad/cad-core'

/**
 * 将 `.puppy` manifest 中的文档类型映射为 imported-model 标签类型。
 *
 * 设计说明：
 * 1. 离线包导入不能继承当前空工程的默认零件模式，否则装配树会被误合并为实体列表；
 * 2. 文档类型必须由离线包 manifest 决定，web-client 只负责把该语义传给标签与设计树链路。
 *
 * @param documentType `.puppy` manifest 记录的 CAD 文档类型。
 * @returns imported-model 标签类型。
 */
export function resolveOfflinePuppyTabType(
  documentType: PuppyPackageDocumentType | undefined,
): ImportedModelTabType {
  return documentType === 'assembly' ? 'assembly' : 'part'
}
